import workspaceQuery from '../../../graphql/queries/sales/ImportedAmazonOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedAmazonOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedAmazonOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedAmazonOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedAmazonOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedAmazonOrderAggregateQuery.graphql';

import { workspace } from '../../../actions/sales/ImportedOrderWorkspaceAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const ImportedAmazonOrder = {
  type: 'ImportedAmazonOrder',
  title: 'Amazon Orders',
  formTitle: 'Imported Amazon Order',
  workspaceUrl: '/Sales/Channel/ImportedAmazonOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedAmazonOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_AMAZON_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedAmazonOrder;
